import type { FeedPost } from '../types/post';

/** Posts with a missing flag stay shareable for older/partial API payloads. */
export const canSharePost = (
  post: Pick<FeedPost, 'allowShare'> | null | undefined,
): boolean => post?.allowShare !== false;
